import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../state'
import * as content from '../../../../content'

import * as quiverDeploymentModal from './quiver-deployment-modal'

/**
 * Displays zone applications and permitted app creation or deletion actions.
 */
@ngCore.Component({
  imports: [
    ds.table.Component,
    ds.overlay.confirmation.Component,
    content.admin.modals.app.Component,
    quiverDeploymentModal.Component,
  ],
  providers: [quiverDeploymentModal.Store],
  selector: 'atn-admin-zone-page-apps-tab',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.admin.apps.Collection} */
  public readonly appsEc = ngCore.inject(state.admin.apps.Collection)

  /** @see {@link state.admin.contexts.Feature} */
  private readonly _contextsFeature = ngCore.inject(
    state.admin.contexts.Feature,
  )

  /** @see {@link state.me.Feature} */
  private readonly _meFeature = ngCore.inject(state.me.Feature)

  /** @see {@link quiverDeploymentModal.Store} */
  public readonly quiverDeploymentModalStore = ngCore.inject(
    quiverDeploymentModal.Store,
  )

  /** Whether the current admin user can create apps */
  public readonly canCreateAppSg = ngCore.computed(() =>
    state.admin.portalAccess.ContentActionAccess.canCreateChild({
      context: this._contextsFeature.selectors.zoneContext.asSignal(),
      user: this._meFeature.selectors.currentUser.asSignal(),
    }),
  )

  /** Canonical table input for applications in the current zone. */
  public readonly appsTableConfigSg = ngCore.computed(() => {
    const canCreate = this.canCreateAppSg()
    return {
      collection: this.appsEc,
      view: {
        creation: canCreate,
        search: true,
        showColumnSettings: false,
        title: 'Applications',
        toolbarTools: canCreate
          ? [
              {
                iconClass: 'atn-icon atn-run atn-blue',
                id: 'quiver-deployment',
                onClick: () => this.quiverDeploymentModalStore.start(),
              },
            ]
          : [],
      },
    } satisfies ds.table.ec.Config.Input<state.admin.apps.TypeParams>
  })

  /** Name of the app marked for deletion */
  public appNameForDeleteSg = ngCore.computed(
    (
      [deletedApp] = this.appsEc.plugins.editingPlugin.feature.selectors
        .deletedEntities()
        .asSignal(),
    ) => deletedApp?.name,
  )

  /**
   * Handles the confirmation action for application deletion.
   */
  public confirmDeletionClickHandler(): void {
    this.appsEc.plugins.editingPlugin.feature.actions.submit
      .from('Confirmation.Footer.Buttons.Confirm.Clicked')
      .dispatch({ delete: true })
  }

  /**
   * Handles the cancellation action for application deletion.
   */
  public cancelDeletionClickHandler(): void {
    this.appsEc.plugins.editingPlugin.feature.actions.discard
      .from('Confirmation.Footer.Buttons.Cancel.Clicked')
      .dispatch({ delete: true })
  }
}
